module.exports = __webpack_public_path__ + "img/footer-logo.176c7a78.png";